import { createApiClient } from './createApiClient';
import { resolveApiBaseUrl } from './resolveApiBaseUrl';

type PassthroughOptions = Pick<
  Parameters<typeof createApiClient>[0],
  | 'onUnauthorized'
  | 'refreshPath'
  | 'getRefreshToken'
  | 'setAccessToken'
  | 'setRefreshToken'
  | 'clientPlatform'
>;

export interface AppApiClientOptions extends PassthroughOptions {
  baseURL?: string;
  withCredentials?: boolean;
  timeout?: number;
  headers?: Record<string, string>;
  getToken?: () => string | null;
}

export const createAppApiClient = ({
  baseURL = resolveApiBaseUrl(),
  withCredentials = false,
  timeout = 10000,
  headers,
  getToken,
  ...passthrough
}: AppApiClientOptions = {}) => {
  return createApiClient({
    baseURL,
    withCredentials,
    timeout,
    headers: {
      'Content-Type': 'application/json',
      ...(headers || {}),
    },
    getToken,
    ...passthrough,
  });
};
